export enum ProfileName {
  IntermediarioARS = "Intermediario ARS",
  IntermediarioSeguros = "Intermediario Seguros",
  HealthProvider = "Prestadores de Salud",
  ClientesCorporativos = "Clientes Corporativos",
  Banca = "Banca",
  LOJACK = "LOJACK",
  Aerodom = "Aerodom",
  Fiduciary = "Fiduciaria",
  Provider = "Prestador",
}
